import React, { FC } from "react";
import { classNames } from "repoV2/utils/common/render/classNames";
import styles from "./AccountUpdateOtpVerification.module.scss";
import formStyles from "../../userDetails.module.scss";
import { IAccountUpdateOtpVerification } from "./AccountUpdateOtpVerification.interfaces";

const AccountUpdateOtpVerification: FC<IAccountUpdateOtpVerification> = ({
    otp,
    error,
    onChange,
}) => {
    return (
        <div className={styles.root}>
            <p className={styles.info}>
                An OTP has been sent to your registered email or phone number.
                Please check your email or phone, and enter the code here to
                complete the verification process.
            </p>

            <div className={styles.fieldContainer}>
                <input
                    value={otp}
                    className={classNames(
                        formStyles.formInput,
                        error ? formStyles.formInputError : null,
                        styles.input
                    )}
                    maxLength={6}
                    placeholder="Enter OTP"
                    onChange={e => onChange?.(e.target.value)}
                />
                {error ? (
                    <div
                        className={classNames(
                            formStyles.fieldError,
                            styles.errorText
                        )}
                    >
                        {error}
                    </div>
                ) : null}
            </div>
        </div>
    );
};

export default AccountUpdateOtpVerification;
